/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Practice_HintInputs */

const en_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short drills for putting, bunker play, irons, and full swing.`)
};

const es_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios cortos de putting, bunker, hierros y swing completo.`)
};

const de_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurze Übungen zum Putten, Bunkerspiel, Eisen und Vollschwung.`)
};

const zh_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推杆、沙坑、铁杆和全挥杆的短时练习。`)
};

const ar_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمارين قصيرة للباتينغ، والرمل، والأيرون، والسوينغ الكامل.`)
};

const fr_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices courts pour le putting, le jeu de bunker, les fers et le swing complet.`)
};

const vi_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài tập ngắn cho putting, bunker, gậy sắt và swing đầy đủ.`)
};

const sw_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mazoezi mafupi ya putting, kupiga kutoka bunker, vyuma na swing kamili.`)
};

const th_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การฝึกซ้อมระยะสั้นสำหรับพัตต์ บังเกอร์เพลย์ เหล็ก และฟูลสวิง`)
};

const bs_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kratke vježbe za puttanje, igru iz bunkera, željeza i puni zamah.`)
};

const ja_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パッティング、バンカーショット、アイアン、フルスイングのための短いドリル。`)
};

const ko_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`퍼팅, 벙커 플레이, 아이언, 풀스윙을 위한 짧은 드릴.`)
};

const pt_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios curtos de putting, jogo de bunker, ferros e swing completo.`)
};

const it_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi brevi per putting, gioco dal bunker, ferri da golf e swing completo.`)
};

const sv_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korta övningar för puttning, bunkerspel, järnslag och full sving.`)
};

const nl_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korte oefeningen voor putten, bunkerslagen, ijzers en de volledige swing.`)
};

const da_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korte øvelser til putning, bunkerslag, jernslag og fuldt sving.`)
};

const nb_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korte øvelser for putting, bunkerslag, jernslag og full sving.`)
};

const fi_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lyhyitä harjoitteita puttaamiseen, bunkkerilyönteihin, rautalyönteihin ja täyteen swingiin.`)
};

const pl_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krótkie ćwiczenia z puttowania, gry z bunkra, uderzeń żelazami i pełnego swingu.`)
};

const ru_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Короткие упражнения на патт, игру из бункера, удары айронами и полный свинг.`)
};

const tr_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putt, bunker vuruşları, demir sopalar ve tam swing için kısa alıştırmalar.`)
};

const hi_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पटिंग, बंकर शॉट, आयरन और फुल स्विंग के लिए छोटी ड्रिल।`)
};

const id_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan singkat untuk putting, pukulan bunker, iron, dan ayunan penuh.`)
};

const ms_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latih tubi ringkas untuk putting, permainan bunker, kayu besi dan hayunan penuh.`)
};

const cs_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krátká cvičení na patování, hru z bunkru, železa a plný švih.`)
};

const el_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σύντομες ασκήσεις για putting, παιχνίδι από τον bunker, σίδερα και πλήρες σβινγκ.`)
};

const he_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תרגילים קצרים לפאטינג, למשחק מהבונקר, לחבטות ברזל ולסווינג מלא.`)
};

const af_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kort oefeninge vir putt, bunkerspel, ysterhoue en die volle swaai.`)
};

const hu_lessons_practice_hint = /** @type {(inputs: Lessons_Practice_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rövid gyakorlatok puttoláshoz, bunkerjátékhoz, vasütésekhez és teljes swinghez.`)
};

/**
* | output |
* | --- |
* | "Short drills for putting, bunker play, irons, and full swing." |
*
* @param {Lessons_Practice_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_practice_hint = /** @type {((inputs?: Lessons_Practice_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Practice_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_practice_hint(inputs)
	if (locale === "de") return de_lessons_practice_hint(inputs)
	if (locale === "zh") return zh_lessons_practice_hint(inputs)
	if (locale === "ar") return ar_lessons_practice_hint(inputs)
	if (locale === "fr") return fr_lessons_practice_hint(inputs)
	if (locale === "vi") return vi_lessons_practice_hint(inputs)
	if (locale === "sw") return sw_lessons_practice_hint(inputs)
	if (locale === "th") return th_lessons_practice_hint(inputs)
	if (locale === "bs") return bs_lessons_practice_hint(inputs)
	if (locale === "ja") return ja_lessons_practice_hint(inputs)
	if (locale === "ko") return ko_lessons_practice_hint(inputs)
	if (locale === "pt") return pt_lessons_practice_hint(inputs)
	if (locale === "it") return it_lessons_practice_hint(inputs)
	if (locale === "sv") return sv_lessons_practice_hint(inputs)
	if (locale === "nl") return nl_lessons_practice_hint(inputs)
	if (locale === "da") return da_lessons_practice_hint(inputs)
	if (locale === "nb") return nb_lessons_practice_hint(inputs)
	if (locale === "fi") return fi_lessons_practice_hint(inputs)
	if (locale === "pl") return pl_lessons_practice_hint(inputs)
	if (locale === "ru") return ru_lessons_practice_hint(inputs)
	if (locale === "tr") return tr_lessons_practice_hint(inputs)
	if (locale === "hi") return hi_lessons_practice_hint(inputs)
	if (locale === "id") return id_lessons_practice_hint(inputs)
	if (locale === "ms") return ms_lessons_practice_hint(inputs)
	if (locale === "cs") return cs_lessons_practice_hint(inputs)
	if (locale === "el") return el_lessons_practice_hint(inputs)
	if (locale === "he") return he_lessons_practice_hint(inputs)
	if (locale === "af") return af_lessons_practice_hint(inputs)
	if (locale === "hu") return hu_lessons_practice_hint(inputs)
	return en_lessons_practice_hint(inputs)
});